import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const updateBIAButtonTreatmentSelector = createSelector(testTargetOffersSelector, offers => offers.updateBIAButtonTreatment || Empty.Object);

export { updateBIAButtonTreatmentSelector };
